import React, { PureComponent } from 'react';

import styles from './styles.less';
import Icon from '~/UI/Icon';
import { TailwindTooltip } from '~/libs/ui/atoms/TailwindTooltip/TailwindTooltip';

interface Props {
	style: React.CSSProperties;
}

export default class Header extends PureComponent<Props> {
	public static defaultProps = {
		style: null,
	};

	public render() {
		const { style } = this.props;

		return (
			<div className={styles.header} style={style}>
				<div className={styles.addOrRemoveCell} />
				<div className={styles.countryCell}>Country</div>
				<div className={styles.brandCell}>Brand name</div>
				<div className={styles.mahCell}>Company</div>
				<div className={styles.dosageCell}>Dosage Form</div>
				<div className={styles.dosageStrengthCell}>Dosage strength</div>
				<div className={styles.packageCell}>Package</div>
				<div className={styles.referencePriceCell}>
					Price
					<TailwindTooltip
						reference={<Icon name='violet-question-mark' />}
						displayClass='inline-block ml-2 h-4 align-top'
						position='left'
					>
						<p className='leading-snug'>
							<strong>Upper Price:</strong> Ex-factory price (either published or calculated)
						</p>
						<p className='leading-snug'>
							<strong>Lower Price (in bold):</strong> Original price published in the data source (either Ex-factory
							price or price used per Ex-factory price calculation)
						</p>
					</TailwindTooltip>
				</div>
				<div className={styles.packageForCalculationCell}>Package for calc.</div>
				<div className={styles.priceCell}>
					Calc. Price
					<TailwindTooltip
						reference={<Icon name='violet-question-mark' />}
						displayClass='inline-block ml-2 h-4 align-top'
						position='left'
					>
						<p className='leading-snug'>
							<strong>Calc. price:</strong> Price calculated by multiplying price (in the Price field) by package size
							(in the Package for calc. field)
						</p>
						<p className='leading-snug'>
							<strong>Upper Price:</strong> Ex-factory price (either published or calculated)
						</p>
						<p className='leading-snug'>
							<strong>Lower Price (in bold):</strong> Original price published in the data source (either Ex-factory
							price or price used per Ex-factory price calculation)
						</p>
					</TailwindTooltip>
				</div>
				<div className={styles.selectionCell}>Use for calc.</div>
				<div className={styles.usedForCalculationCell} />
			</div>
		);
	}
}
